import React, { useState } from 'react';
import { projects } from '../data/mock';
import { Calendar, Building2, Award, ChevronLeft, ChevronRight } from 'lucide-react';
import '../styles/Projects.css';

const Projects = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState({});

  const handleNextImage = (projectId, imagesLength) => {
    setCurrentImageIndex(prev => ({
      ...prev,
      [projectId]: ((prev[projectId] || 0) + 1) % imagesLength
    }));
  };

  const handlePrevImage = (projectId, imagesLength) => {
    setCurrentImageIndex(prev => ({
      ...prev,
      [projectId]: ((prev[projectId] || 0) - 1 + imagesLength) % imagesLength
    }));
  };

  return (
    <section className="projects-section" id="projects">
      <div className="projects-container">
        <h2 className="section-title">Projects</h2>
        
        <div className="projects-grid">
          {projects.map((project) => (
            <div key={project.id} className="project-card">
              {project.images && project.images.length > 0 && (
                <div className="project-image-wrapper">
                  <img 
                    src={project.images[currentImageIndex[project.id] || 0]} 
                    alt={project.title}
                    className="project-image"
                  />
                  {project.images.length > 1 && (
                    <>
                      <button 
                        className="image-nav-btn prev"
                        onClick={() => handlePrevImage(project.id, project.images.length)}
                        aria-label="Previous image"
                      >
                        <ChevronLeft size={24} />
                      </button>
                      <button 
                        className="image-nav-btn next"
                        onClick={() => handleNextImage(project.id, project.images.length)}
                        aria-label="Next image"
                      >
                        <ChevronRight size={24} />
                      </button>
                      <div className="image-indicators">
                        {project.images.map((_, idx) => (
                          <span 
                            key={idx} 
                            className={`indicator ${idx === (currentImageIndex[project.id] || 0) ? 'active' : ''}`}
                            onClick={() => setCurrentImageIndex(prev => ({ ...prev, [project.id]: idx }))}
                          />
                        ))}
                      </div>
                    </>
                  )}
                </div>
              )}
              
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                
                <div className="project-meta">
                  <div className="project-meta-item">
                    <Calendar size={16} />
                    <span>{project.period}</span>
                  </div>
                  <div className="project-meta-item">
                    <Building2 size={16} />
                    <span>{project.institution}</span>
                  </div>
                </div>
                
                <p className="project-description">{project.description}</p>
                
                {project.achievements.length > 0 && (
                  <div className="project-achievements">
                    <h4 className="achievements-title">
                      <Award size={16} />
                      Highlights
                    </h4>
                    <ul className="achievements-list">
                      {project.achievements.map((achievement, idx) => (
                        <li key={idx}>{achievement}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;